export const name = 'qr';

export const QR = () => (
  <svg
    viewBox="0 0 24 24"
    fill="none"
    color="#161619"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M11.0999 3V11.1H2.99991V3L11.0999 3ZM9.29994 4.80001H4.79992V9.30003H9.29994V4.80001Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M8.39993 5.69995H5.69992V8.39996H8.39993V5.69995Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M11.0999 12.9V21.0001H2.99991V12.9H11.0999ZM9.29994 14.7H4.79992V19.2001H9.29994V14.7Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M5.69992 15.6H8.39993V18.3H5.69992V15.6Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12.8999 18.3H15.5999V21.0001H12.8999V18.3Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M15.5999 15.6H18.3V18.3H15.5999V15.6Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12.8999 12.9H15.5999V15.6H12.8999V12.9Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M18.3 15.6H21V18.3H18.3V15.6Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M18.3 12.9H21V15.6H18.3V12.9Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M18.3 18.3H21V21.0001H18.3V18.3Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M20.9999 3V11.1H12.8999V3L20.9999 3ZM19.1999 4.80001H14.6999V9.30003H19.1999V4.80001Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M15.5999 5.69995H18.3V8.39996H15.5999V5.69995Z"
      fill="currentColor"
    />
  </svg>
);
